import { render, staticRenderFns } from "./ViewPosts.vue?vue&type=template&id=2d02e75e&scoped=true"
import script from "./ViewPosts.vue?vue&type=script&lang=js"
export * from "./ViewPosts.vue?vue&type=script&lang=js"
import style0 from "./ViewPosts.vue?vue&type=style&index=0&id=2d02e75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d02e75e",
  null
  
)

export default component.exports